import { useState } from 'react';
import { Theme, SxProps, Tooltip, Box, IconButton } from '@mui/material';
import { HugeiconsIcon } from '@hugeicons/react';
import { HelpCircleIconStroke } from '@/components/icons';
import { HelpTopicDrawer } from './help-topic-drawer';

interface InfoProps {
    children?: React.ReactNode;
    sx?: SxProps<Theme>;
    infoText?: React.ReactNode;
    /** Required slug for help-cms content (`https://help-cms.hd.pics/{path}`). */
    helpTopicPath: string;
    iconSize?: number;
}

export const Info = ({
    children,
    infoText,
    helpTopicPath,
    sx,
    iconSize = 16,
    ...props
}: InfoProps) => {
    const [isHelpDrawerOpen, setIsHelpDrawerOpen] = useState(false);
    const [shouldPreloadHelp, setShouldPreloadHelp] = useState(false);

    const handleOpenHelp = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        setShouldPreloadHelp(true);
        setIsHelpDrawerOpen(true);
    };

    const handlePreloadHelp = () => {
        setShouldPreloadHelp(true);
    };

    const icon = (
        <IconButton
            size="small"
            aria-label="Open help"
            onClick={handleOpenHelp}
            onMouseEnter={handlePreloadHelp}
            onFocus={handlePreloadHelp}
            sx={{
                p: 0,
                cursor: 'pointer'
            }}
        >
            <HugeiconsIcon icon={HelpCircleIconStroke} size={iconSize} strokeWidth={1.5} />
        </IconButton>
    );

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    ...sx
                }}
                {...props}
            >
                {children}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {infoText ? <Tooltip title={infoText}>{icon}</Tooltip> : icon}
                </Box>
            </Box>
            <HelpTopicDrawer
                open={isHelpDrawerOpen}
                preload={shouldPreloadHelp}
                onClose={() => setIsHelpDrawerOpen(false)}
                helpTopicPath={helpTopicPath}
            />
        </>
    );
};
